import { OrderMainStatus } from 'services/order/order.type';
import { useAppDispatch, useAppSelector } from 'state/store';
import { getStatuses, updateOrdersStatus } from 'state/ordersStatus/ordersStatus.slice';
import {
    getOrderStatusAcknowledged,
    updateOrdersStatusAcknowledged,
} from 'state/ordersStatusAcknowledged/ordersStatusAcknowledged.slice';

export const useOrderStatus = () => {
    const dispatch = useAppDispatch();
    const ordersStatus = useAppSelector(getStatuses);
    const ordersStatusAcknowledged = useAppSelector(getOrderStatusAcknowledged);

    const initializeOrderStatus = (
        orderId: string,
        restaurantId: string,
        mainStatus: OrderMainStatus,
    ) => {
        if (!ordersStatus || !ordersStatus[orderId]) {
            const status = [
                OrderMainStatus.ORDER_CANCELLED,
                OrderMainStatus.ORDER_REFUSED,
            ].includes(mainStatus)
                ? 'CANCELLED'
                : 'LOADING';

            const initOrdersStatus = {
                [orderId]: {
                    orderId,
                    restaurantId,
                    status,
                },
            };
            dispatch(updateOrdersStatus(initOrdersStatus));

            const initOrdersStatusAcknowledged = {
                [orderId]: !!ordersStatusAcknowledged?.[orderId],
            };
            dispatch(updateOrdersStatusAcknowledged(initOrdersStatusAcknowledged));
        }
    };

    return {
        ordersStatus,
        ordersStatusAcknowledged,
        initializeOrderStatus,
    };
};
